import { useEffect, useState } from "react";
import { Grid, Typography, Box, CircularProgress } from "@mui/material";
import QuizCard from "../components/QuizCard";
import { api } from "../api";
import { useTheme } from "@mui/material/styles";


export default function Quizzes({ category, onStartTraining }) {
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    setLoading(true);

    api.getQuizzesByCategory(category)
      .then(setQuizzes)
      .catch((err) => {
        console.error("Failed to load quizzes", err);
        setQuizzes([]);
      })
      .finally(() => setLoading(false));
  }, [category]);

  if (loading) {
    return (
      <Box sx={{ mt: 6, textAlign: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 6 }}>
      <Typography
        variant="h4"
        fontWeight={800}
        sx={{ mb: 4, textAlign: "center", color: theme.custom.colors.grey }}
      >
        Quiz {category.toUpperCase()}
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {quizzes.map((quiz) => (
          <Grid item key={quiz.id}>
            <QuizCard
              quiz={quiz}
              onTrain={onStartTraining}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
